<script lang="ts" setup>
/**
 * リプライ情報 > テナント公式回答表示。
 */
</script>

<template>
	<div class="revico-community-talk-reply-details-reply-tenant-icon">テナント公式回答</div>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	&-reply-details-reply-tenant-icon {
		position: absolute;
		top: -24px;
		right: 0;
		padding: 4px 12px;
		font-size: 0.8em;
		font-weight: bold;
		background-color: var(--base-bg-color);
	}
}
</style>
